module.exports = __webpack_public_path__ + "static/img/Ned-Bowman.c982737.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ned-Bowman.jpg
// module id = Yez4
// module chunks = 0